export default __webpack_public_path__ + "static/media/helmet1.0264d9d1.svg";